// extracted by mini-css-extract-plugin
export default {"container":"styles_container__N-f29","text":"styles_text__ILG72","sideText":"styles_sideText__w+cQn"};